const namespace = window.VelotricBundle
if (!namespace?.["shell"]?.ready) { throw new Error("vl-bundle-shell.js must execute before vl-bundle-catalog.js") }
const sharedApi = namespace["shell"].api
if (!sharedApi) { throw new Error("Missing shell named API contract") }
export const isEnterKey = sharedApi["isEnterKey"]
export const isEscKey = sharedApi["isEscKey"]
export const isLeftKey = sharedApi["isLeftKey"]
export const isRightKey = sharedApi["isRightKey"]
export const isSpaceKey = sharedApi["isSpaceKey"]
export const isTabKey = sharedApi["isTabKey"]